/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index menu to autogenerate all the components and extensions
 * Used by "prepareMenus"
 */

import Menu from './menu/Menu'
export * from './menu/Menu'
export default Menu
